import { PropsWithChildren } from 'react';
import { IBreadcrumbItem, CustomBreadcrumbs } from '@/widgets/CustomBreadcrumbs';
import LogoIcon from '@/shared/assets/icons/complex/logo/logo-black.complex.svg';
import { Svg } from '@/shared/ui/Svg';
import { routerPath } from '@/shared/config/router';

interface ProfileRequestShellProps extends PropsWithChildren {
  title: string;
  breadcrumbs?: IBreadcrumbItem[];
}

export const ProfileRequestShell = ({ title, breadcrumbs, children }: ProfileRequestShellProps) => (
  <section className="relative min-h-[calc(100vh-120px)] overflow-hidden rounded-[28px] bg-white px-8 py-8">
    <div className="relative z-10 flex flex-col gap-8">
      <div className="flex flex-col gap-6">
        <CustomBreadcrumbs
          items={breadcrumbs ?? [{ label: 'My profile', href: routerPath.profile }, { label: title }]}
        />
      </div>
      {children}
    </div>
    <Svg
      Icon={LogoIcon}
      className="pointer-events-none absolute right-8 top-[120px] z-0 w-[420px] opacity-[0.06]"
    />
  </section>
);
